import { actions, mutations } from '../constants'
import request from '@/utils/request'

const auth = {
  state: {
    countries:[],
    services:[],
  },
  mutations: {
    [mutations.MUNDIHUB_SET_COUNTRIES](state, countries){
      state.countries = countries;
    },
    [mutations.MUNDIHUB_SET_SERVICES](state, countries){
      state.countries = countries;
    }
  },
  actions: {
    [actions.MUNDIHUB_GET_COUNTRIES]({commit, state}){
      if(state.countries.length>0){
        return Promise.resolve(state.countries);
      }
      return request({
        method: 'GET',
        url: 'countries'
      }).then(res=>{
          const {
            data:{
              items: countries = []
            }={}
          } = res;
          commit(mutations.MUNDIHUB_SET_COUNTRIES, countries);
          return Promise.resolve(countries);
      })
    },
    [actions.MUNDIHUB_GET_SERVICES]({commit, state}){
      return request({
        method: 'GET',
        url: 'services',
        params: {
          country_id: 1
        }
      }).then(res=>{
        const {
          data:{
            items: services = []
          }={}
        } = res;
        return Promise.resolve(services);
      })
    }
  }
};

export default auth;



// WEBPACK FOOTER //
// ./src/store/modules/mundihub.js